(() => {
  const STORAGE_KEY = 'vatIncluded';

  function getVatMode() {
    return localStorage.getItem(STORAGE_KEY) !== '0';
  }

  function updateVatPrices(withVat) {
    document.querySelectorAll('[data-price-with-vat]').forEach((el) => {
      const price = withVat
        ? el.dataset.priceWithVat
        : el.dataset.priceWithoutVat;

      if (price !== undefined) {
        el.innerHTML = price;
      }

      el.style.visibility = 'visible';
    });

    document.querySelectorAll('.js-tax-text').forEach((el) => {
      el.innerHTML = withVat
        ? el.dataset.withVat
        : el.dataset.withoutVat;
    });
  }

  function updateVatSwitcher(withVat) {
    const input = document.getElementById('VatSwitcher');
    const label = document.getElementById('VatSwitcherLabel');

    if (!input || !label) {
      return;
    }

    input.checked = withVat;

    label.innerHTML = withVat
      ? label.dataset.withVat
      : label.dataset.withoutVat;
  }

  function updateAll(withVat) {
    document.documentElement.dataset.vatIncluded = withVat
      ? 'true'
      : 'false';

    updateVatPrices(withVat);
    updateVatSwitcher(withVat);
  }

  function refreshVatMode() {
    const withVat = getVatMode();

    updateAll(withVat);
  }

  /*
   * Initial state.
   *
   * Default:
   * - no localStorage value -> Tax excl.
   * - "0" -> Tax excl.
   * - "1" -> With VAT.
   */
  refreshVatMode();

  /*
   * Switcher change.
   */
  document.addEventListener('change', (event) => {
    if (event.target.id !== 'VatSwitcher') {
      return;
    }

    const withVat = event.target.checked;

    localStorage.setItem(
      STORAGE_KEY,
      withVat ? '1' : '0'
    );

    updateAll(withVat);

    document.dispatchEvent(
      new CustomEvent('vat-mode-changed', {
        detail: {
          included: withVat
        }
      })
    );
  });

  /*
   * Custom event from other scripts.
   */
  document.addEventListener('vat-mode-changed', (event) => {
    if (event.detail && typeof event.detail.included === 'boolean') {
      updateAll(event.detail.included);
    }
  });

  /*
   * Shopify variant changes.
   */
  document.addEventListener('variant:change', refreshVatMode);

  /*
   * Shopify section reloads.
   */
  document.addEventListener('shopify:section:load', refreshVatMode);

})();